import { E3DGrpAuthState } from './reducers/e3DGrpAuthReducer'

const AUTH_STORAGE = window.localStorage
const E3D_GRP_AUTH_KEY = 'dcc-e3d-grp-auth'

export const persistE3DGrpAuth = (authState: E3DGrpAuthState): void => {
    try {
        AUTH_STORAGE.setItem(E3D_GRP_AUTH_KEY, JSON.stringify(authState))
    } catch (e) {
        console.error('[persistAuthState] Failed to save e3DGrpAuth state:', e)
    }
}

export const getPersistedE3DGrpAuth = (): E3DGrpAuthState | null => {
    try {
        const stored = AUTH_STORAGE.getItem(E3D_GRP_AUTH_KEY)
        if (!stored) {
            return null
        }
        return JSON.parse(stored) as E3DGrpAuthState
    } catch (e) {
        return null
    }
}

export const clearPersistedE3DGrpAuth = (): void => {
    try {
        AUTH_STORAGE.removeItem(E3D_GRP_AUTH_KEY)
    } catch (e) {
        console.error('[persistAuthState] Failed to clear e3DGrpAuth state:', e)
    }
}
